
import { Vue } from "vue-class-component";

export default class EmptyRouterView extends Vue {}
